var cifJm = ["301 151", "<defs><path id='a' d='M.5.5h300v150H.5z'/></defs><g fill='none' fill-rule='evenodd'><path fill='#009B3A' fill-rule='nonzero' d='M.5.5h300v150H.5z'/><mask id='b' fill='#fff'><use xlink:href='#a'/></mask><path fill='#000' fill-rule='nonzero' stroke='#FED100' stroke-width='20' d='M300.5.5l-150 75 150 75M.5.5l150 75-150 75' mask='url(#b)'/></g>"];

export { cifJm };

